import {
    EDIT_LEG_LIST,
    GET_LEGS_SUCCESS,
    GET_LEGS_TOTAL_SUCCESS,
    GET_SINGLE_TRIP_SUCCESS,
    GET_PATIENT_TRIPS_SUCCESS,
    LEG_CSV_IMPORT_SUCCESS
} from "./legs.types";

const initialState = {
    legsList: null,
    patientTrips: null,
    singleTrip: null,
    legTotals: null,
    importedLegs: null,
};

export const legsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LEGS_SUCCESS:
            return {
                ...state,
                legsList: action?.payload,
            };

            case EDIT_LEG_LIST:
            return {
                ...state,
                legsList: action?.payload,
            };

        case GET_PATIENT_TRIPS_SUCCESS:
            return {
                ...state,
                patientTrips: action?.payload,
            };


        case GET_SINGLE_TRIP_SUCCESS:
            return {
                ...state,
                singleTrip: action?.payload,
            };

        case GET_LEGS_TOTAL_SUCCESS:
            return {
                ...state,
                legTotals: action?.payload,
            };

            case LEG_CSV_IMPORT_SUCCESS:
            return {
                ...state,
                importedLegs: action?.payload,
            };

        default:
            return state;
    }
};
